import { Box, Button, Section, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  integration_name: string
}

const EmployeesData = ({ integration_name }: Props) => {
  const { navigation } = useNavigation()

  return (
    <Section
      illustration="window-user"
      title={i18n.t('codes.employees_data.title')}
      description={i18n.t('codes.employees_data.description', {
        integration_name,
      })}
    >
      <Box
        background="grey200"
        borderRadius={{
          all: 'abs008',
        }}
        padding="s24"
        gap="s16"
      >
        <Text.Normal>
          {i18n.t('codes.employees_data.card_description', {
            integration_name,
          })}
        </Text.Normal>
        <Button.Router to={navigation.employees.fullPath()} type="secondary">
          {i18n.t('codes.employees_data.button')}
        </Button.Router>
      </Box>
    </Section>
  )
}

export default EmployeesData
